import React from 'react'
import Grid from "@mui/material/Grid"
import LayoutBox from "../../global/LayoutBox"
import Box from "@mui/material/Box"
import {useQuery} from "@apollo/client"
import {GET_STRIPE_PRODUCTS} from "./graphql"
import Spinner from "../../global/Spinner"
import ProductItem from "../../product/ProductItem"


function PriceTable() {

    const {data, loading} = useQuery(GET_STRIPE_PRODUCTS)
    const {getStripeProducts: products} = (data) ? data : {'getStripeProducts': []}


    return (
        <Grid container>
            <Grid item xs={12}>
                {loading ?
                    <Spinner/>
                    :
                    <Box className="bg-gray">
                        <LayoutBox pb={6} mb={4}>
                            <Box sx={{textAlign: "center", width: "100%"}} mt={4} pb={4}><h1>Choose your plan</h1></Box>
                            <Grid container spacing={4}>
                                {
                                    (data && !loading) &&
                                    products.map((item, index) => (
                                        <Grid item xs={12} md={6}
                                              key={`product-list-item-${index}`}
                                        >
                                            <ProductItem
                                                title={item.title}
                                                description={item.description}
                                                price={item.price}
                                                interval={item.interval}
                                                priceId={item.priceId}
                                            />
                                        </Grid>
                                    ))

                                }
                            </Grid>
                        </LayoutBox>
                    </Box>
                }
            </Grid>
        </Grid>
    )
}

export default PriceTable